import { io } from "socket.io-client";
import { notification } from "antd";
import { domain } from "../config";
// Create and export the socket instance
export const socket = io(domain, {
  autoConnect: false,
  transports: ["websocket", "polling"],
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

// Internal callback refs
let onAisleAddedCallback = null;
let onLocationAddedCallback = null;
let onProductCallback = null;
let onReminderCallback = null;

// Flag to prevent duplicate listener setup
let listenersSetup = false;

// Register callbacks
export const registerAisleAddedCallback = (callback) => {
  console.log("📥 Aisle callback registered");
  onAisleAddedCallback = callback;
};

export const registerLocationAddedCallback = (callback) => {
  console.log("📥 Location callback registered");
  onLocationAddedCallback = callback;
};

export const registerProductCallback = (callback) => {
  console.log("📥 Product callback registered:", callback?.name || "anonymous");
  onProductCallback = callback;
};

// Optional: Add a way to check if callback is still needed
export const clearProductCallback = () => {
  console.log("🧹 Clearing product callback");
  onProductCallback = null;
};

export const registerReminderCallback = (callback) => {
  console.log("📥 Reminder callback registered");
  onReminderCallback = callback;
};

export const clearReminderCallback = () => {
  onReminderCallback = null;
};

// Setup listeners once
export const setupSocketListeners = () => {
  if (listenersSetup) {
    console.log("⚠️ Socket listeners already setup, skipping");
    return;
  }
  console.log("🔧 Setting up socket listeners");
  listenersSetup = true;

  socket.on("connect", () => {
    console.log("✅ Socket connected:", socket.id);
    socket.emit("join_user");
  });

  socket.on("disconnect", () => {
    console.log("❌ Socket disconnected");
  });

  socket.on("aisle_added", (data) => {
    console.log("📦 aisle_added event received:", data);
    notification.success({
      message: "Aisle Added",
      description: data.message,
      duration: 4,
    });
    if (onAisleAddedCallback) {
      onAisleAddedCallback();
    } else {
      console.warn("⚠️ No aisle callback registered");
    }
  });

  socket.on("aisle_updated", (data) => {
    console.log("📦 aisle_updated event received:", data);
    notification.success({
      message: "Aisle Updated",
      description: data.message,
      duration: 4,
    });
    if (onAisleAddedCallback) {
      onAisleAddedCallback();
    } else {
      console.warn("⚠️ No aisle callback registered");
    }
  });

  socket.on("location_added", (data) => {
    console.log("📦 location_added event received:", data);
    notification.success({
      message: "Location Added",
      description: data.message,
      duration: 4,
    });
    if (onLocationAddedCallback) {
      onLocationAddedCallback();
    } else {
      console.warn("⚠️ No location callback registered");
    }
  });

    socket.on("location_updated", (data) => {
    console.log("📦 location_updated event received:", data);
    notification.success({
      message: "Location Updated",
      description: data.message,
      duration: 4,
    });
    if (onLocationAddedCallback) {
      onLocationAddedCallback();
    } else {
      console.warn("⚠️ No location callback registered");
    }
  });

  socket.on("product_updated", (data) => {
    notification.success({
      message: "Products sync started",
      description: data.message,
      duration: 4,
    });
    if (onProductCallback) {
      onProductCallback();
    } else {
      console.warn("⚠️ No product callback registered");
    }
  });


socket.on("product_location_added", (data) => {
    console.log("📦 product_location_added event received:", data);
    notification.success({
      message: "product Location Added",
      description: data.message,
      duration: 4,
    });
    if (onProductCallback) {
      onProductCallback();
    } else {
      console.warn("⚠️ No product location callback registered");
    }
  });
  

  socket.on("product_location_updated", (data) => {
    console.log("📦 product_location_updated event received:", data);
    notification.success({
      message: "Picking Location Updated",
      description: data.message,
      duration: 4,
    });
    if (onProductCallback) {
      onProductCallback();
    } else {
      console.warn("⚠️ No product location callback registered");
    }
  });

  socket.on("reminder_added", (data) => {
  console.log("⏰ reminder_added event received:", data);

  if (onReminderCallback) {
    onReminderCallback(data);
  } else {
    console.warn("⚠️ No reminder callback registered");
  }
});
}